


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import Icon from "../Icon.vue";
import TextLink from "../TextLink.vue";
import { ShareNetwork } from "vue-social-sharing";

@Component({
  components: {
    Icon,
    TextLink,
    ShareNetwork,
  },
})
export default class Header extends Vue {
  scrollUp() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
